import { render, staticRenderFns } from "./CourseMiddlePage.vue?vue&type=template&id=502b53ea&scoped=true&"
import script from "./CourseMiddlePage.vue?vue&type=script&lang=js&"
export * from "./CourseMiddlePage.vue?vue&type=script&lang=js&"
import style0 from "./CourseMiddlePage.vue?vue&type=style&index=0&id=502b53ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b53ea",
  null
  
)

export default component.exports